import type { SearchableField } from "@salon/types";
import { BOOKING_BEHAVIOR_SEARCH } from "../features/booking-behavior/search";
import { BUSINESS_SEARCH } from "../features/business/search";
import { LIMITS_SEARCH } from "../features/capacity/search";
import { ONLINE_BOOKING_SEARCH } from "../features/online/search";
import { SALON_CONFIG_SEARCH } from "../features/salon-config/search";
import { WEB_PAGE_SEARCH } from "../features/web-page/search";

/**
 * Aggregated list of all searchable fields across settings sections.
 *
 * Each feature folder under `domains/settings/features/<section>/` exports
 * its own `*_SEARCH` array. Add an import here when a section gains
 * searchable fields. Sections without field-level search still appear in
 * results via the auto-derived section entries (see `use-search-entries`).
 */
export const FIELD_REGISTRY: readonly SearchableField[] = [
  ...SALON_CONFIG_SEARCH,
  ...BOOKING_BEHAVIOR_SEARCH,
  ...ONLINE_BOOKING_SEARCH,
  ...LIMITS_SEARCH,
  ...BUSINESS_SEARCH,
  ...WEB_PAGE_SEARCH,
];
